export const CASHMESTAGE = String.fromCharCode.apply(
  null,
  [99, 97, 115, 104, 115, 116, 97, 103, 105, 110, 103, 46, 109, 101]
)
export const CASHAPPSTAGE = String.fromCharCode.apply(
  null,
  [99, 97, 115, 104, 115, 116, 97, 103, 105, 110, 103, 46, 97, 112, 112]
)

export const isDev = () => ['localhost', '0.0.0.0'].includes(window.location.hostname)
export const isStaging = () => [CASHAPPSTAGE, CASHMESTAGE].includes(window.location.hostname)
